import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_chevron",
  "use": "svg_chevron-usage",
  "viewBox": "0 0 14 9",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 9\" id=\"svg_chevron\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.703 8.516a1 1 0 0 1-1.414 0L6.997 3.223 1.714 8.515A1 1 0 0 1 .298 7.102l5.99-6 .708.707-.708-.706A1.002 1.002 0 0 1 7.703 1.1l6 6a1 1 0 0 1 0 1.415Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol